import { exportExcel } from "@api/stores/employeeActivities/exportExcel/api";
import { exportPDF } from "@api/stores/employeeActivities/exportPDF/api";
import { createGetAllApi } from "@api/util/createGetAllApi";

import type { IApiResponse, IPagination, IPaginationParams } from "@api";

import type { IPathBaseParam } from "./path";
import type {
  IEmployeeActivitiesGetAllParams,
  IEmployeeActivitiesResponse,
} from "./types";

const getAllApis = createGetAllApi<
  IApiResponse<IPagination<IEmployeeActivitiesResponse>>,
  IPathBaseParam,
  IPaginationParams & IEmployeeActivitiesGetAllParams
>("stores.employeeActivities");

export const employeeActivities = {
  ...getAllApis,
  exportPDF,
  exportExcel,
};
